var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 7L4.66666 28H11.6667V46.6667H44.3333V28H51.3333L28 7ZM16.3333 42V23.7767L28 13.2767L39.6667 23.7767V42H16.3333ZM32.6667 32.6667C32.6667 35.2333 30.5667 37.3333 28 37.3333C25.4333 37.3333 23.3333 35.2333 23.3333 32.6667C23.3333 30.1 28 23.3333 28 23.3333C28 23.3333 32.6667 30.1 32.6667 32.6667Z",
    fill: "#FDCA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDamage);
export default __webpack_public_path__ + "static/media/water-damage.e6d38159d1eb2a76aefcba26f156a7e8.svg";
export { ForwardRef as ReactComponent };